import { useMemo } from 'react';
import usePdpLayout from '@hooks/product/use-pdp-layout';
import { useRouter } from 'next/router';
import useFeatureFlag from '@hooks/use-feature-flags';

const useHeroPdpStyles = () => {
  const { query } = useRouter();
  const { isSemPDP } = useFeatureFlag();
  const isHeroPDP = (query?.product_id && !isSemPDP) ?? '';
  const { isRecirculation } = usePdpLayout();

  const isHeroPdpStyles = useMemo(() => {
    return isHeroPDP || isRecirculation;
  }, [query, isRecirculation]);

  return { isHeroPdpStyles, isHeroPDP, isSemPDP };
};
export default useHeroPdpStyles;
